import React, { useState } from "react";
import { errorNoti } from "../../../../../base/BasicNotifications";
import {
  CommentComposer,
  CommentIcon,
  CommentList,
} from "../../../StrategyCanvas/StrategyCanvasHelpers";
import { ERROR_COPY, LIMITS } from "../../_config/quarterlyOkrConfig";
import "./_review-comment-thread.scss";

// The coach's comments on one target — an objective, a person or the company
// (§9.3). Strategy Canvas's `CommentList` / `CommentComposer`, so every
// review in the coach app comments the same way. No edit: the contract has
// no PUT for comments; `CommentList` without `onEdit` renders delete only.
const ReviewCommentThread = ({
  comments,
  readOnly,
  addLabel = "Add a comment for the CEO",
  placeholder = "Add context, a question, or a suggested change",
  saving,
  deletingId,
  onAdd,
  onDelete,
}) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState("");

  const handleSave = async () => {
    const text = draft.trim();
    if (!text || saving) return;
    if (text.length > LIMITS.COMMENT_MAX_CHARS) {
      errorNoti(ERROR_COPY.invalid_comment);
      return;
    }
    try {
      await onAdd(text);
      setDraft("");
      setOpen(false);
    } catch {
      // The caller surfaced the error; the draft stays so nothing is lost.
    }
  };

  return (
    <div className="qokr-comment-thread">
      {comments.length ? (
        <CommentList
          comments={comments}
          onDelete={onDelete}
          deletingId={deletingId}
          readOnly={readOnly}
        />
      ) : null}

      {!readOnly && !open ? (
        <button
          type="button"
          className="rr-comment-link"
          onClick={() => setOpen(true)}
        >
          <CommentIcon size={12} />
          {comments.length ? "Add another comment" : addLabel}
        </button>
      ) : null}

      {!readOnly && open ? (
        <CommentComposer
          value={draft}
          onChange={setDraft}
          onSave={handleSave}
          saving={saving}
          placeholder={placeholder}
        />
      ) : null}
    </div>
  );
};

export default ReviewCommentThread;
